enum PeCompanyEstimateAction {
  Buy = 1,
  Hold = 2,
  Sell = 3,
}

export default PeCompanyEstimateAction;
